const SearchConstants = {
    MOVIE: 'P',
    SERIE: 'S',
    CHANNEL: 'L',
    EVENT: 'E',
    TALENT: 'TALENT',
    RECORDING: 'RECORDING',
    TALENT_TYPE_NORMAL: 'TALENT_TYPE_NORMAL',
    TALENT_TYPE_EXTERNAL: 'TALENT_TYPE_EXTERNAL',
    NEWEVENT: 'Z',
    NEW: 'NEW',
    OLD: 'OLD',
    PASSTIME: 24,
    FUTRETIME:48,
    AMCO: 'amco',
    SUBSCRIPTION: 'susc',

     //Cantidad de Elementos
    quantity: 3,
    FOCUSABLE: 'focusable focusable_search',
    FOCUSABLE_BUTTON: 'focusable_button',
    FOCUSABLE_CARD: 'focusable_card',

  SEARCH_FOUND: 'SEARCH_FOUND',
  SEARCH_NOT_FOUND: 'SEARCH_NOT_FOUND',
  SEARCH_NOT_FOUND_KIDS: 'SEARCH_NOT_FOUND_KIDS',
  SEARCH_POPULAR: 'SEARCH_POPULAR',
  SEARCH_EMPTY: 'SEARCH_EMPTY',

    //TEXTO
    BUTTON_MORE_INFO: 'BUTTON_MORE_INFO',
    KEY_CONTENT_TYPE: 'content_type',
    FROM_SERIES: 'FROM_SERIES',
    FROM_SEARCH_COMPONENT_AAF: 'FROM_SEARCH_COMPONENT_AAF',

    //ERRORES
    MESSAGE_ERROR_NOT_AVAILABLE_ANY_PROFILE: 'BYR_PAR_00006',
    MESSAGE_ERROR_NOT_AVAILABLE_KIDS: 'BYR_PAR_00005',
  };

export default SearchConstants;


// WEBPACK FOOTER //
// ./src/containers/Search/SearchConstants.js